import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import axios from '../axios';
import LoadingModal from './LoadingModal';
import { SelectedAuthorizer } from '../types/CustomerDocumentEdit';
import { KWANKGM10090A04 } from '../const/api_modules';

interface Props {
  show: boolean;
  handleCancel: VoidFunction;
  handleApply: (authorizer: SelectedAuthorizer[]) => void;
}

const ModalAuthorizerSelect: React.FC<Props> = ({
  show,
  handleCancel,
  handleApply,
}) => {
  // 承認者一覧
  const [authorizer_list, setAuthorizerList] = useState<SelectedAuthorizer[]>([]);
  // 検索文字列
  const [search_string, setSearchString] = useState('');
  // ローディング
  const [is_loading, setIsLoading] = useState(false);
  
  // TODO レスポンスのモック、APIが提供されたら削除する
  const mock_response = {
    data: {
      result: true,
      message: '',
      list: [
        { id: '1', name: '承認者太郎' },
        { id: '2', name: '承認者二郎' },
        { id: '3', name: '承認者三郎' },
        { id: '4', name: '承認者四郎' },
        { id: '5', name: '承認者五郎' },
        { id: '6', name: '承認者六郎' },
        { id: '7', name: '承認者七郎' },
        { id: '8', name: '承認者八郎' },
        { id: '9', name: '承認者九郎' },
        { id: '10', name: '承認者十郎' },
        { id: '11', name: '承認者十一郎' },
      ]
    }
  }

  // 検索ボタン押下処理
  const handleClickSearchButton = async () => {
    try {
      setIsLoading(true);

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
        reception_id: '',
        reception_cd: null,
        module_name: KWANKGM10090A04,
        search_text: {
          val: search_string,
        },
        is_json: true,
      });

      if (!response.data.result) {
        throw(response);
      }

      setAuthorizerList(response.data.detail[0].value);
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  // 結果リストを表示する
  const jsxResultList = () => {
    if (authorizer_list.length === 0) {
      return [];
    }

    // クリックイベント
    const handleClickAuthorizer = (index: number) => {
      const new_authorizer_list = [
        authorizer_list[index]
      ]
      handleApply(new_authorizer_list);
      handleCancel();
    };

    const list: JSX.Element[] = [];
    authorizer_list.map((item, index) => {
      list.push(
        <td className="table-td" key={`authorizer-list-${index}`} onClick={() => { handleClickAuthorizer(index) }}>{item.name}</td>
      );
    });

    return list;
  };

  // 検索文字列を入力する
  const handleChangeSearchString = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchString(event.target.value);
  }

  return (
    <Modal
      className="d-flex justify-content-center align-items-center modal-item-select"
      show={show}
      animation={false}
      onHide={() => {}}
    >
      <div className="modal__inner">
        <div className="modal__contents modal-contents-authorizer">
          <img className="modal2-close modal__close js-img-switch js-fade-in" src="/img/ico_012_sp.png" alt="close" onClick={handleCancel} />
          <div className="p-heading3-box">
            <h3 className="heading3">承認者選択</h3>
          </div>
          <div className="p-lead modal_wrapper">
            <div className="modal_input">
              <label className="modal_label">職員名</label>
              <input className="c-input input_xs ml-2" type="text" value={search_string} onChange={handleChangeSearchString} />
            </div>
            <br />
            <div className="modal_input">
              <a className="c-btn btn-mini btn-green modal3-open modal_button" onClick={handleClickSearchButton}>検索</a>
            </div>
          </div>
          <div className="p-heading4-box">
            <h4 className="heading4 -mycar" style={{display: "flex"}}>
              <div className="col-md-2 vertical">
                <div className="after-margin">一覧</div>
              </div>
            </h4>
          </div>
          <table className="p-form-table">
            <tbody>
              <tr className="p-form-table-box js-search-param2">
                {jsxResultList()}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <LoadingModal show={is_loading} />
    </Modal>
  );
};

export default ModalAuthorizerSelect;